// extracted by mini-css-extract-plugin
module.exports =  {"alert":"nQBr9BjE4fynaQ55Avoe","container":"sXeenWIjkW1rLsdHjDBN","containerWide":"iwa4HcNSXMfW1KekhRXK","editor":"pZ7Tfvc9RjJa2sJweuww"};